<template>
  <div>
    <!-- Start banner -->
    <home-banner></home-banner>
    <!-- End banner -->
    <div
      class="home-content">
      <div
        class="content-polygon"
      ></div>
      <!-- Start statistics -->
      <home-statistics
      ></home-statistics>
      <!-- End statistics -->
      <!-- Start statistics -->
      <home-aboutus
        class="section-spacing"
      ></home-aboutus>
      <!-- End statistics -->
      <!-- Start Testimonial -->
      <!-- <home-testimonial
        class="section-spacing"
      ></home-testimonial> -->
      <!-- End Testimonial -->
      <!-- Start disclamer -->
      <home-disclamer
        class="section-spacing"
      ></home-disclamer>
      <!-- End disclamer-->
      <!-- Start Testimonial -->
      <home-image-gallery
        class="section-spacing"
      ></home-image-gallery>
      <!-- End Testimonial -->
    </div>
  </div>
</template>
<script>
export default {
  components: {
    // banner
    HomeBanner: () => import('@/components/Home/Banner.vue'),
    // statistics
    HomeStatistics: () => import('@/components/Home/Statistics.vue'),
    // about us
    HomeAboutus: () => import('@/components/Home/AboutUs.vue'),
    // tersimonials
    HomeTestimonial: () => import('@/components/Home/Testimony.vue'),
    // disclaimers
    HomeDisclamer: () => import('@/components/Home/Disclamer.vue'),
    // image gallery
    HomeImageGallery: () => import('@/components/Home/Images.vue'),
  }
}
</script>
<style scoped>
  .content-polygon {
    margin-bottom: -1px;
    z-index: 2;
    position: relative;
    background-color: white;
    clip-path: polygon(0 0,100% 100%,100% 0,100% 10%,100% 100%,0 100%);
    height: 150px;
    width: 100%;
  }
  .home-content {
    max-width: 100vw;
    overflow: hidden;
    padding-top: 100vh;
    position: relative;
  }
</style>